// dependencies
import React from "react";
import { StyleSheet } from "react-native";

// components
import Text from "@cloudspire/legacy-resources/src/components/Text";

// libraries
import { emToPx } from "@cloudspire/legacy-resources/src/libraries";

type PropsType = {
  errorList: string[];
};

const styles = StyleSheet.create({
  fieldError: {
    color: "#ffffff",
    padding: emToPx(0.3125),
    backgroundColor: "#c75a00",
    fontSize: emToPx(0.75),
    fontWeight: "700",
  },
});

const FieldError: React.FunctionComponent<PropsType> = (props) => {
  const { errorList } = props;

  return <Text style={styles.fieldError}>{errorList.join("\n")}</Text>;
};

export default FieldError;
